import gql from 'graphql-tag';

// Recomputes the overall rating from the four dimension values via the
// EvaluationMatrix lookup — still used to re-rate matrix-era curations.
export const GET_OVERALL_GQL = gql`
  query ($ratings: [RatingInput!]!) {
    appRatingComputation(ratings: $ratings)
  }
`;
